module.exports = __webpack_public_path__ + "img/oca-color.8ccd1e82.png";